export const addressFieldLabels = {
  address_line1: 'Street address',
  address_line2: 'Apartment, unit, or other',
  country: 'Country',

  subregion: {
    area: 'Area',
    county: 'County',
    department: 'Department',
    district: 'District',
    do_si: 'Do Si',
    emirate: 'Emirate',
    island: 'Island',
    oblast: 'Oblast',
    parish: 'Parish',
    prefecture: 'Prefecture',
    province: 'Province',
    state: 'State',
  },

  locality: {
    city: 'City',
    district: 'District',
    post_town: 'Town or city',
    suburb: 'Suburb',
  },

  dependentLocality: {
    suburb: 'Suburb',
    district: 'District',
    neighborhood: 'Neighborhood',
    village_township: 'Village or township',
    townland: 'Townland',
  },

  postalCode: {
    postal: 'Postal code',
    eircode: 'Eircode',
    pin: 'PIN',
    zip: 'Zip code',
  },

  sortingCode: {
    sorting: 'Sorting code',
    cedex: 'CEDEX',
  },
};

type MutableNestedPartial<T> = {
  -readonly [K in keyof T]?: T[K] extends Record<string, unknown>
    ? MutableNestedPartial<T[K]>
    : T[K];
};

export type FieldLabelOverrides = MutableNestedPartial<
  typeof addressFieldLabels
>;
